"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialAvailability = exports.getHighlights = exports.getAvailability = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var getHighlights = function getHighlights(option) {
  return option.connections;
};
exports.getHighlights = getHighlights;
var getFullAvailability = function getFullAvailability(variantGroups) {
  return variantGroups.reduce(function (acc, currentGroup) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, currentGroup.id, currentGroup.options.map(function (option) {
      return option.value;
    })));
  }, {});
};
var getInitialAvailability = function getInitialAvailability(variantGroups) {
  if (variantGroups.length !== 2) {
    return getFullAvailability(variantGroups);
  }
  return variantGroups.reduce(function (acc, currentGroup) {
    var selectedOption = currentGroup.options.find(function (o) {
      return o.isSelected;
    });
    return _objectSpread(_objectSpread({}, acc), selectedOption.connections);
  }, {});
};
exports.getInitialAvailability = getInitialAvailability;
var getAvailability = function getAvailability(variantGroups, option, groupId) {
  if (variantGroups.length !== 2) {
    return getFullAvailability(variantGroups);
  }
  var currentGroup = variantGroups.find(function (group) {
    return group.id === groupId;
  });
  return _objectSpread(_objectSpread({}, option.connections), {}, (0, _defineProperty2["default"])({}, currentGroup.id, currentGroup.options.map(function (o) {
    return o.value;
  })));
};
exports.getAvailability = getAvailability;